// Psychologist/SpecializationsPicker.tsx
import React, {useEffect} from 'react';
import {Box, Checkbox, FormControlLabel, Typography} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {fetchPsychologyParams} from "Redux/psychologyParamsSlice";
import {AppDispatch, RootState} from "Redux/store";
import {Controller} from 'react-hook-form';
import {IPsychologistSpecialization} from "../../Types/psychology/psychologist";

interface SpecializationsPickerProps {
    control: any;
}

const SpecializationsPicker: React.FC<SpecializationsPickerProps> = ({control}) => {
    const dispatch = useDispatch<AppDispatch>();
    const {specializations, status} = useSelector((state: RootState) => state.psychologyParams);

    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchPsychologyParams());
        }
    }, [status, dispatch]);

    if (status === 'loading') {
        return <Typography>Загрузка специализаций...</Typography>;
    }

    if (status === 'failed') {
        return <Typography color="error">Ошибка загрузки специализаций</Typography>;
    }

    return (
        <Box>
            {specializations && specializations.length > 0 ? (
                <Controller
                    name="specializations"
                    control={control}
                    render={({field}) => (
                        <Box
                            display="grid"
                            gridTemplateColumns="repeat(2, 1fr)"
                            gap={0} // Добавьте отступы между чекбоксами по необходимости
                        >
                            {specializations.map((spec: IPsychologistSpecialization) => (
                                <FormControlLabel
                                    key={spec.id}
                                    control={
                                        <Checkbox
                                            className={'p-1'}
                                            checked={field.value.includes(spec.id)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    field.onChange([...field.value, spec.id]);
                                                } else {
                                                    field.onChange(field.value.filter((id: number) => id !== spec.id));
                                                }
                                            }}
                                        />
                                    }
                                    label={spec.name}
                                />
                            ))}
                        </Box>
                    )}
                />
            ) : (
                <Typography>Нет доступных специализаций.</Typography>
            )}
        </Box>
    );
};

export default SpecializationsPicker;
